// Layout.tsx
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = () => {
  const location = useLocation();

  return (
    <div className="flex flex-col min-h-screen bg-white font-sans text-gray-900">
      <Navbar />
      <main className="flex-grow bg-white">
        <Outlet key={location.pathname} />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
